// extracted by mini-css-extract-plugin
export default {"text":"overview_text__8NdeL"};